import React from 'react';

export const LazyTodayWeatherPage = React.lazy(() => import('./TodayWeatherPage'));
export const LazyWeatherHistoryPage = React.lazy(() => import('./WeatherHistoryPage'));
export const LazyLightningHistoryPage = React.lazy(() => import('./LightningHistoryPage'));
